import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { IInputState, IInputMessage } from '../../types';
import { InlineSpinner, SVG } from 'components';
import { Text } from 'components/ui';
import { Icons } from 'assets';
import { MessageContainer } from './message.styled';

type MessageProps = {
  state: IInputState;
  message: Partial<IInputMessage>;
};

export const Message: FC<MessageProps> = observer(({ state, message }) => {
  return (
    <MessageContainer $state={state}>
      {state === 'pending' ? (
        <InlineSpinner color="primary.600" />
      ) : (
        <SVG
          src={
            state === 'success'
              ? Icons.CheckCircleFilled
              : state === 'default'
                ? Icons.InformationCircleFilled
                : Icons.CrossCircleFilled
          }
          complex
        />
      )}
      <Text>{message[state]}</Text>
    </MessageContainer>
  );
});
